import EditCustomer from '../../pages/Customer/EditCustomer';
import { CustomerController } from '../../controllers';
import { MimaToastUtil } from '../../components';
import { customerStore, userStore } from '../../stores';
import constant from '../../utils/constant';
import React, { useState } from 'react';
import { observer } from 'mobx-react';
import { toJS } from 'mobx';
import * as yup from 'yup';
import { phoneRegExp } from '../../utils/utils';
import { useGetAllActiveReviews } from '../../controllers/SurveyController';

const EditCustomerContainer = ({ closeModal, goBack, setShowSurvey }) => {
	const { needFeedback } = useGetAllActiveReviews(
		constant.FEEDBACK.CUSTOMERUPDATE
	);

	const [loading, setLoading] = useState(false);

	const customerDetailsValidation = () => {
		return yup.object({
			fullname: yup.string().required('Customer name is required'),
			mobile: yup
				.string()
				.matches(phoneRegExp, 'Phone number is not valid')
				.required('Customer phone number is required'),
		});
	};

	const onSubmit = async payload => {
		setLoading(true);
		for (const key in payload) {
			if (payload[key] === '') {
				delete payload[key];
			}
		}

		const { status, errorMessage } = await CustomerController.updateCustomer(
			payload,
			customerStore.selectedCustomer._id
		);
		if (status === constant.Success) {
			setLoading(false);
			MimaToastUtil.success({
				message: constant.Success,
			});
			closeModal();
			if (needFeedback._id) {
				setShowSurvey(true);
				userStore.setReviewId(needFeedback._id);
			}
			return;
		}
		setLoading(false);
		return MimaToastUtil.error({
			message: errorMessage,
		});
	};

	return (
		<EditCustomer
			closeModal={closeModal}
			loading={loading}
			customer={toJS(customerStore.selectedCustomer)}
			onSubmit={onSubmit}
			customerDetailsValidation={customerDetailsValidation}
			goBack={goBack}
		/>
	);
};

export default observer(EditCustomerContainer);
